import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { useNotifications } from 'contexts/notification-context';
import { useState, useEffect } from 'react';
import TopBar from 'components/shared/TopBar';
import { AlertSnackBar } from 'components/AlertSnackBar';
import { STATUS_TO_SEVERITY } from 'constants';

const LayoutRoot = () => {
  const { latestNotification, clearLatestNotification } = useNotifications();
  const [snackbarKey, setSnackbarKey] = useState(null);

  const handleClose = () => {
    setSnackbarKey(null);
    clearLatestNotification();
  };

  useEffect(() => {
    if (latestNotification) {
      setSnackbarKey(Date.now().toString());
    }
  }, [latestNotification]);

  const getMessage = (notification) => {
    if (!notification) {
        return '';
    }

    switch (notification.status) {
      case 'Success':
        return 'Employee manual successfully indexed!';
      case 'Failure':
        return 'Failed to index employee manual. Please try again.';
      case 'InProgress':
        return 'Indexing employee manual...';
      default:
        return `Status: ${notification.status}`;
    }
  };

  return (
    <Box>
      <Box>
        <TopBar />
      </Box>
      <main>
        <Outlet />
      </main>
      {latestNotification && snackbarKey && (
        <AlertSnackBar
          key={snackbarKey}
          message={getMessage(latestNotification)}
          severity={STATUS_TO_SEVERITY[latestNotification.status] || 'info'}
          onClose={handleClose}
        />
      )}
    </Box>
  );
};

export default LayoutRoot;
